import { useState, useEffect } from "react";

const NAV_LINKS = [
  { label: "Início", href: "#hero" },
  { label: "Áreas", href: "#areas" },
  { label: "Sobre", href: "#sobre" },
  { label: "Diferenciais", href: "#diferenciais" },
  { label: "Contato", href: "#contato" },
];

const WA_LINK =
  "https://wa.me/5581995913182?text=Ol%C3%A1%2C%20gostaria%20de%20saber%20mais%20sobre%20os%20servi%C3%A7os%20de%20advocacia%20previd%C3%AAncia";

const LOGO_DEFAULT =
  "https://storage.readdy-site.link/project_files/18151d51-7801-4abd-9f16-f614da2e415d/f32fd3aa-f0c3-4503-86b0-c39d0bec8d64_foto-logo-sm-sem-nome-Photoroom.png?v=e32c19c982c497803cd9f042aeba2dba";
const LOGO_LIGHT =
  "https://storage.readdy-site.link/project_files/18151d51-7801-4abd-9f16-f614da2e415d/a59d050e-dd50-455f-9ad9-f9d3b2575f8f_m-clara.png?v=4526a1b287edd10cb53e6317eeac57fd";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        (scrolled || menuOpen) ? "border-b border-white/10" : "bg-transparent"
      }`}
      style={{
        padding: "20px",
        backgroundColor: (scrolled || menuOpen) ? "rgb(61, 35, 32)" : "transparent",
      }}
    >
      {/* ── DESKTOP layout: 3-column grid ── */}
      <div className="hidden md:grid max-w-7xl mx-auto grid-cols-3 items-center">
        {/* Logo — left */}
        <a
          href="#hero"
          onClick={(e) => {
            e.preventDefault();
            handleNavClick("#hero");
          }}
          className="flex items-center cursor-pointer justify-start"
        >
          <img
            src={scrolled ? LOGO_LIGHT : LOGO_DEFAULT}
            alt="Martins Advocacia Logo"
            style={{ height: "92px", width: "auto" }}
            className="object-contain transition-all duration-500"
          />
        </a>

        {/* Nav links — center */}
        <nav className="flex items-center justify-center gap-10">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => {
                e.preventDefault();
                handleNavClick(link.href);
              }}
              className="font-body text-[11px] font-light tracking-[0.18em] uppercase transition-all duration-300 ease-in-out cursor-pointer text-white/60 hover:text-white/95"
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* CTA — right */}
        <div className="flex items-center justify-end">
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer nofollow"
            className={`font-body text-sm font-semibold px-6 py-2.5 transition-colors duration-300 whitespace-nowrap tracking-wide ${
              scrolled ? "bg-white hover:bg-gray-100" : "bg-white hover:bg-gray-50"
            }`}
            style={{ color: "rgb(61, 35, 32)", borderRadius: "40px" }}
          >
            Entre em contato
          </a>
        </div>
      </div>

      {/* ── MOBILE layout: logo centered, hamburger absolute right ── */}
      <div className="md:hidden relative flex items-center justify-center max-w-7xl mx-auto">
        {/* Logo — centered */}
        <a
          href="#hero"
          onClick={(e) => {
            e.preventDefault();
            handleNavClick("#hero");
          }}
          className="flex items-center cursor-pointer"
        >
          <img
            src={(scrolled || menuOpen) ? LOGO_LIGHT : LOGO_DEFAULT}
            alt="Martins Advocacia Logo"
            style={{ height: "72px", width: "auto" }}
            className="object-contain transition-all duration-500"
          />
        </a>

        {/* Hamburger — absolute right */}
        <button
          className="absolute right-0 w-9 h-9 flex items-center justify-center cursor-pointer transition-colors text-white"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <i className={`ri-${menuOpen ? "close" : "menu"}-line text-2xl`} />
        </button>
      </div>

      {/* Mobile Menu Dropdown */}
      {menuOpen && (
        <div
          className="md:hidden border-t border-white/10 px-6 py-5 flex flex-col gap-4 mt-2"
          style={{ backgroundColor: "rgb(61, 35, 32)" }}
        >
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => {
                e.preventDefault();
                handleNavClick(link.href);
              }}
              className="font-body text-[11px] font-light tracking-[0.18em] uppercase text-white/60 cursor-pointer hover:text-white/95 transition-all duration-300 ease-in-out"
            >
              {link.label}
            </a>
          ))}
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="font-body text-sm font-semibold bg-white px-5 py-3 text-center whitespace-nowrap tracking-wide mt-1"
            style={{ color: "rgb(61, 35, 32)", borderRadius: "40px" }}
          >
            Entre em contato
          </a>
        </div>
      )}
    </header>
  );
}
